import { render, staticRenderFns } from "./GalleryLightbox.vue?vue&type=template&id=a2aeae5e"
import script from "./GalleryLightbox.vue?vue&type=script&lang=js"
export * from "./GalleryLightbox.vue?vue&type=script&lang=js"
import style0 from "./GalleryLightbox.vue?vue&type=style&index=0&id=a2aeae5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports